module.exports = __webpack_public_path__ + "img/img.122a8866.png";